/** Domínio final esperado após normalização (subdomínio myshopify). */
const MYSHOPIFY_HOST_RE = /^[a-z0-9-]+\.myshopify\.com$/;

export function isValidMyshopifyShopDomain(shop) {
  return MYSHOPIFY_HOST_RE.test(shop);
}

/**
 * Normaliza entrada para `nome-loja.myshopify.com`.
 * Aceita: subdomínio só (`minhaloja`), `minhaloja.myshopify.com`,
 * ou URL do admin: `https://admin.shopify.com/store/minhaloja` (e subpaths).
 */
export function normalizeShopifyShopInput(value) {
  const raw = value.trim();
  if (!raw) return '';

  let urlStr = raw;
  if (!/^https?:\/\//i.test(urlStr)) {
    urlStr = `https://${urlStr}`;
  }

  try {
    const u = new URL(urlStr);
    const host = u.hostname.toLowerCase();

    if (host === 'admin.shopify.com') {
      const m = u.pathname.match(/^\/store\/([^/?#]+)/i);
      if (m) {
        const slug = decodeURIComponent(m[1]).toLowerCase();
        if (/^[a-z0-9-]+$/.test(slug)) {
          return `${slug}.myshopify.com`;
        }
      }
    }

    if (host.endsWith('.myshopify.com')) {
      const sub = host.slice(0, -'.myshopify.com'.length);
      if (/^[a-z0-9-]+$/.test(sub)) {
        return `${sub}.myshopify.com`;
      }
    }
  } catch {
    // segue para fallback
  }

  let s = raw.toLowerCase().trim();
  s = s.replace(/^https?:\/\//i, '');
  const slash = s.indexOf('/');
  if (slash >= 0) s = s.slice(0, slash);
  const colon = s.indexOf(':');
  if (colon >= 0) s = s.slice(0, colon);

  if (s.endsWith('.myshopify.com')) {
    const sub = s.slice(0, -'.myshopify.com'.length);
    if (/^[a-z0-9-]+$/.test(sub)) return s;
  }

  if (s && !s.includes('.')) {
    return `${s}.myshopify.com`;
  }

  return s;
}

export const getConfiguredShopifyLoginHost = () => {
  const raw = process.env.REACT_APP_SHOPIFY_LOGIN_DOMAIN || '';
  return raw.replace(/^https?:\/\//, '').replace(/\/$/, '').toLowerCase();
};

/** Host atual para comparar com o domínio configurado (inclui porta se não for 80/443). */
export const getCurrentHostWithPort = () => {
  if (typeof window === 'undefined') return '';
  const hostname = window.location.hostname.toLowerCase();
  const port = window.location.port;
  if (!port || port === '80' || port === '443') {
    return hostname;
  }
  return `${hostname}:${port}`;
};

export const getCurrentHostWithPortAndProtocol = () => {
  let host = getCurrentHostWithPort();
  let schema = window.location.protocol;
  return `${schema}//${host}`;
};

export const isShopifyLoginDomain = () => {
  if (typeof window === 'undefined') return false;
  const configuredHost = getConfiguredShopifyLoginHost();
  if (!configuredHost) return false;
  return getCurrentHostWithPort() === configuredHost;
};

